import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import propTypesExact from "prop-types-exact"
import React from "react"
import {Text} from "shared/base"
import {View} from "react-native"
/**
 * @typedef {object} ComponentsUtilsCodeProps
 * @property {unknown} children
 * @property {unknown} textProps
 * @property {unknown} viewProps
 */

/** @typedef {object} ComponentsUtilsCodeState */

/**
 * @extends {ShapeComponent<ComponentsUtilsCodeProps, ComponentsUtilsCodeState>}
 */
class ComponentsUtilsCode extends ShapeComponent {
  static propTypes = propTypesExact({
    children: PropTypes.node,
    textProps: PropTypes.object,
    viewProps: PropTypes.object
  })

  render() {
    const {textProps = {}, viewProps = {}} = this.props
    const {style: viewStyle, ...restViewProps} = viewProps
    const actualViewStyle = Object.assign(
      {
        padding: 20,
        backgroundColor: "#dcdcdc",
        borderRadius: 7
      },
      viewStyle
    )
    const {style: textStyle, ...restTextProps} = textProps
    const actualTextStyle = Object.assign({fontFamily: "monospace"}, textStyle)

    return (
      <View style={actualViewStyle} {...restViewProps}>
        <Text style={actualTextStyle} {...restTextProps}>
          {this.props.children}
        </Text>
      </View>
    )
  }
}

export default memo(shapeComponent(ComponentsUtilsCode))
